import { FileService } from "@/base/api/api.service"
import {
    UPLOAD_FILE,
    DEL_FILE
} from "@/store/actions.type"

import {
    UPDATE_FILE,
    ADD_FILE,
    REMOVE_FILE
} from "@/store/mutations.type"
/* eslint-disable */
export default {
    [UPLOAD_FILE]({ commit }, payload) {
        commit(ADD_FILE, {
            uploaded: false,
            uploadProgress: 0,
            deleting: false,
            ...payload.photo
        })
        const uploading = FileService.uploadFile(payload.photo, (snapshot) => {
            let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            commit(UPDATE_FILE, {
                id: payload.photo.id,
                values: {
                    uploadProgress: Math.round(progress)
                }
            })
        })

        uploading.then((urls) => {
            commit(UPDATE_FILE, {
                id: payload.photo.id,
                values: {
                    uploaded: true,
                    file_url_firebase: urls[0],
                    thumbnail_url_firebase: urls[1]
                }
            })
        })
    },
    
    [DEL_FILE]({ commit, state }, id) {
        const file = state.photos.find(photo => photo.id === id)
        commit(UPDATE_FILE, {
            id: id,
            values: {
                deleting: true
            }
        })
        FileService.deleteFile(file)
            .then(() => {
                commit(REMOVE_FILE, id)
            })
    }
}